/**
 * Баннер победителя боя
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Показывает баннер победителя боя
 * @param {object} winner - Объект победителя с полями team, owner, name
 */
export function showBattleWinnerBanner(winner) {
  const banner = document.getElementById("battle-winner-banner");
  if (!banner) return;
  
  if (!winner) {
    hideBattleWinnerBanner();
    return;
  }
  
  // Удаляем все классы команд
  banner.classList.remove(
    "battle-winner-banner--team-a",
    "battle-winner-banner--team-b"
  );
  
  // Добавляем класс команды победителя
  if (winner.team && String(winner.team).toUpperCase() === "A") {
    banner.classList.add("battle-winner-banner--team-a");
  } else if (winner.team && String(winner.team).toUpperCase() === "B") {
    banner.classList.add("battle-winner-banner--team-b");
  }
  
  // Обновляем имя и существо
  const nameElement = banner.querySelector(".battle-winner-name");
  const creatureElement = banner.querySelector(".battle-winner-creature");
  
  if (nameElement) {
    nameElement.textContent = winner.owner || winner.name || "—";
  }
  
  if (creatureElement) {
    creatureElement.textContent = winner.name ? winner.name : "";
    creatureElement.style.display = winner.name ? "block" : "none";
  }
  
  // Показываем баннер
  banner.classList.add("active");
}

/**
 * Скрывает баннер победителя боя
 */
export function hideBattleWinnerBanner() {
  const banner = document.getElementById("battle-winner-banner");
  if (!banner) return;
  
  banner.classList.remove(
    "active",
    "battle-winner-banner--team-a",
    "battle-winner-banner--team-b"
  );
  
  const nameElement = banner.querySelector(".battle-winner-name");
  const creatureElement = banner.querySelector(".battle-winner-creature");
  
  if (nameElement) {
    nameElement.textContent = "—";
  }
  
  if (creatureElement) {
    creatureElement.textContent = "";
    creatureElement.style.display = "none";
  }
}











